export interface IEvent {
	Id: number;
	DateOfEvent: string;
	Name: string;
	Description: string;
	Link: string;
	Coordinators: string;
    CoordinatorsCompany: string;
    CoordinatorsPosition: string;
	CoordinatorsPictureId: string;
	IsAdmin: boolean;
	IsInternal: boolean;
	ShowInFeed: boolean;
	CoverImageId: string;
	EventTypeId: number;
	EventType: string;
}

export class CreateEventModel {
	dateOfEvent: Date;
	name: string;
	description: string;
	link: string;
	coordinators: string;
	coordinatorsCompany: string;
	coordinatorsPosition: string;
	coordinatorsPictureId: string;
	isAdmin: boolean;
	isInternal: boolean;
	showInFeed: boolean;
	coverImageId: string;
	eventTypeId: number;
}

export class EditEventModel extends CreateEventModel {
	id: number;
	constructor(item?: IEvent) {
		super();
		this.id = item && item.Id;
		this.dateOfEvent = item && new Date(item.DateOfEvent);
		this.name = item && item.Name;
		this.description = item && item.Description;
		this.link = item && item.Link;
		this.coordinators = item && item.Coordinators;
		this.coordinatorsCompany = item && item.CoordinatorsCompany;
		this.coordinatorsPosition = item && item.CoordinatorsPosition;
		this.coordinatorsPictureId = item && item.CoordinatorsPictureId;
		this.isAdmin = item && item.IsAdmin;
		this.isInternal = item && item.IsInternal;
		this.showInFeed = item && item.ShowInFeed;
		this.coverImageId = item && item.CoverImageId;
		this.eventTypeId = item && item.EventTypeId;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/Event.ts